import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
function Modal({
  title,
  children,
  onClose
}: {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-27">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} transition={{
      duration: 0.25
    }} className="bg-[#111] border border-zinc-800 rounded-xl w-full max-w-2xl max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-28">
        <div className="flex items-center justify-between p-5 border-b border-zinc-800" data-id="element-29">
          <h2 className="text-xl font-bold text-zinc-100 font-display uppercase tracking-wider" data-id="element-30">
            {title}
          </h2>
          <button onClick={onClose} className="text-zinc-500 hover:text-zinc-300 transition-colors p-1" aria-label="Cerrar" data-id="element-31">
            <XIcon size={20} data-id="element-32" />
          </button>
        </div>
        <div className="p-5 md:p-6 overflow-y-auto text-zinc-400 text-sm leading-relaxed space-y-4 text-justify" data-id="element-33">
          {children}
        </div>
        <div className="p-5 border-t border-zinc-800 flex justify-center" data-id="element-34">
          <button onClick={onClose} className="bg-zinc-800 hover:bg-zinc-700 text-zinc-200 font-semibold text-sm py-2.5 px-8 rounded transition-colors" data-id="element-35">
            Cerrar
          </button>
        </div>
      </motion.div>
    </motion.div>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full border-t border-zinc-800/50 bg-[#0A0A0A] z-10 relative" data-id="element-36">
        <div className="max-w-3xl mx-auto px-4 pt-8 pb-[120px] md:pb-8 flex flex-col items-center gap-4" data-id="element-37">
          <div className="flex items-center gap-5" data-id="element-38">
            <button onClick={() => setActiveModal('privacy')} className="text-[#999999] hover:text-brand text-[13px] transition-colors underline-offset-4 hover:underline" data-id="element-39">
              Política de Privacidad
            </button>
            <span className="text-zinc-700" data-id="element-40">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-[#999999] hover:text-brand text-[13px] transition-colors underline-offset-4 hover:underline" data-id="element-41">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-[#777777] text-xs" data-id="element-42">
            © 2024 Protocolo Hora Extra. Todos los derechos reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-43">
        {activeModal === 'privacy' && <Modal title="Política de Privacidad" onClose={() => setActiveModal(null)} data-id="element-44">
            <p data-id="element-45">
              <strong className="text-zinc-200" data-id="element-46">Recopilación</strong>
            </p>
            <p data-id="element-47">
              Solo recopilamos los datos necesarios para procesar su orden y
              entregar el producto digital solicitado.
            </p>

            <p data-id="element-48">
              <strong className="text-zinc-200" data-id="element-49">Uso de datos</strong>
            </p>
            <p data-id="element-50">
              Sus datos se utilizan exclusivamente para la entrega del protocolo
              y comunicaciones relacionadas con su compra. Nunca compartimos ni
              vendemos su información a terceros.
            </p>

            <p data-id="element-51">
              <strong className="text-zinc-200" data-id="element-52">Seguridad</strong>
            </p>
            <p data-id="element-53">
              Utilizamos encriptación de grado bancario para proteger su
              transacción. Su pago es procesado por plataformas seguras
              externas.
            </p>

            <p data-id="element-54">
              <strong className="text-zinc-200" data-id="element-55">Discreción</strong>
            </p>
            <p data-id="element-56">
              El nombre de este producto no aparecerá en sus estados de cuenta
              para proteger su privacidad.
            </p>

            <p data-id="element-57">
              <strong className="text-zinc-200" data-id="element-58">Cookies</strong>
            </p>
            <p data-id="element-59">
              Utilizamos cookies técnicas para asegurar el funcionamiento del
              carrito de compras y la seguridad del sitio.
            </p>
          </Modal>}

        {activeModal === 'terms' && <Modal title="Términos y Condiciones" onClose={() => setActiveModal(null)} data-id="element-60">
            <p data-id="element-61">
              <strong className="text-zinc-200" data-id="element-62">Producto Digital</strong>
            </p>
            <p data-id="element-63">
              Usted está adquiriendo un manual en formato digital (PDF). No se
              enviará ningún material físico.
            </p>

            <p data-id="element-64">
              <strong className="text-zinc-200" data-id="element-65">Propiedad Intelectual</strong>
            </p>
            <p data-id="element-66">
              El contenido de 'Protocolo Hora Extra' es propiedad exclusiva y
              está prohibida su distribución o reventa no autorizada.
            </p>

            <p data-id="element-67">
              <strong className="text-zinc-200" data-id="element-68">Garantía</strong>
            </p>
            <p data-id="element-69">
              Ofrecemos una garantía de satisfacción de 7 días. Si no está
              satisfecho, puede solicitar el reembolso total dentro de este
              periodo.
            </p>

            <p data-id="element-70">
              <strong className="text-zinc-200" data-id="element-71">Responsabilidad</strong>
            </p>
            <p data-id="element-72">
              Este material es informativo. No reemplaza consejo médico
              profesional. El usuario asume la responsabilidad del uso de las
              técnicas descritas.
            </p>

            <p data-id="element-73">
              <strong className="text-zinc-200" data-id="element-74">Acceso</strong>
            </p>
            <p data-id="element-75">
              Usted recibirá un enlace de descarga inmediata tras la
              confirmación exitosa de su pago.
            </p>
          </Modal>}
      </AnimatePresence>
    </>;
}